module.exports = __webpack_public_path__ + "static/media/img-mygood-product-3@3x.63a5f82e.png";